// Skeleton styles are injected inline (not via link tag) to prevent FOUC (Flash of Unstyled Content)
// before the MFE loads. This ensures the skeleton appears styled immediately upon creation.
// Styles use [data-esw-component='payment-panel'] selector for higher specificity to prevent
// being reverted by the payment panel's `all: revert` rule when the MFE loads.
import skeletonStyles from './skeleton-loader.css?raw';

// Inject skeleton styles once
const injectSkeletonStyles = (() => {
  let injected = false;
  return () => {
    if (injected) return;
    injected = true;

    const style = document.createElement('style');
    style.textContent = skeletonStyles;
    document.head.appendChild(style);
  };
})();

const createSkeletonBlock = (className: string): HTMLDivElement => {
  const block = document.createElement('div');
  block.className = `skeleton-block ${className}`;

  const shimmer = document.createElement('div');
  shimmer.className = 'skeleton-shimmer';
  block.appendChild(shimmer);

  return block;
};

const createSkeletonRow = (): HTMLDivElement => {
  const row = document.createElement('div');
  row.className = 'payment-skeleton';

  const leftGroup = document.createElement('div');
  leftGroup.className = 'skeleton-left-group';
  leftGroup.appendChild(createSkeletonBlock('skeleton-circle'));
  leftGroup.appendChild(createSkeletonBlock('skeleton-rect-large'));

  row.appendChild(leftGroup);
  row.appendChild(createSkeletonBlock('skeleton-rect-small'));

  return row;
};

export const createSkeletonLoader = (): HTMLDivElement => {
  injectSkeletonStyles();

  const wrapper = document.createElement('div');
  wrapper.className = 'payment-skeleton-wrapper';
  wrapper.setAttribute('aria-label', 'Loading payment methods');

  wrapper.appendChild(createSkeletonRow());
  wrapper.appendChild(createSkeletonRow());

  return wrapper;
};

export const hideSkeleton = (): void => {
  const container = document.querySelector('[data-esw-component="payment-panel"]');
  if (!container) return;

  const skeleton = container.querySelector('.payment-skeleton-wrapper') as HTMLElement;
  const mfeWrapper = container.querySelector('.payment-panel-content') as HTMLElement;

  if (!skeleton) return;

  skeleton.style.display = 'none';
  if (mfeWrapper) mfeWrapper.style.display = 'block';
};
